import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Alert } from '@/components/atoms/Alert';

import { useAuth } from '../contexts/auth';

import Client from './Client';

export default function Clients() {
    const { clients } = useAuth();
    const { t } = useTranslation();

    if (clients.length === 0) {
        return (
            <div>
                <Alert tone="success">{t('layout.clients.noAccess')}</Alert>
            </div>
        );
    }

    return (
        <Routes>
            <Route path=":clientId/*" element={<Client />} />
            <Route index element={<Navigate to={`/c/${clients[0].id}`} replace />} />
        </Routes>
    );
}
